import React from 'react';
import './ProductsLayout.css';

export function ProductsLayout({ sidebar, content }) {
  return (
    <div className="products-layout">
      {/* Left Sidebar - 300px wide */}
      <aside className="products-sidebar">
        {sidebar}
      </aside>

      {/* Main Content Area - Takes remaining space */}
      <main className="products-content">
        {content}
      </main>
    </div>
  );
}